export const MULTI_SELECT_ACTIONS = ({
  MERGE_POLYGON: 'MERGE_POLYGON',
  SUBTRACT_POLYGON: 'SUBTRACT_POLYGON',
  DELETE_SELECTED_ANNOTATIONS: 'DELETE_SELECTED_ANNOTATIONS'
} as const);
export function mergePolygonAction() {
  return {
    type: MULTI_SELECT_ACTIONS.MERGE_POLYGON
  };
}
export function subtractPolygonAction() {
  return {
    type: MULTI_SELECT_ACTIONS.SUBTRACT_POLYGON
  };
}
export function deleteSelectedAnnotationsAction() {
  return {
    type: MULTI_SELECT_ACTIONS.DELETE_SELECTED_ANNOTATIONS
  };
}
export type MultiSelectActionsT = {
  type: keyof typeof MULTI_SELECT_ACTIONS;
};